import React from "react";
import styled from "styled-components";

// Components
import PricingTable from "../elements/PricingTable";

export default function Pricing() {
	return (
		<div id="top">
			<Wrapper id="resume" className="container">
				<HeaderInfo>
					<h1 className="font40 bold">
						Experience
					</h1>
					<br />
				</HeaderInfo>

				<TablesWrapper className="flexSpaceNull darkBg">
					<TableBoxLarge>
						<PricingTable
							title="Senior Technical Business Analyst"
							text="ANZ Bank | June 2025 - Present"
							offers={[
								{
									name: "Lead end-to-end analysis of complex technical initiatives across multiple domains, provide clear problem framing and structured requirement design.",
									checked: true,
								},
								{
									name: "Facilitate agile ceremonies (PI planning, backlog refinement, workshops) to drive alignment and reduce ambiguity.",
									checked: true,
								},
								{
									name: "Elicit, analyse, and validate functional and non-functional requirements with engineering, risk, and business stakeholders.",
									checked: true,
								},
								{
									name: "Understand and comply with ANZ security, delivery and regulatory banking compliance standards.",
									checked: true,
								},
							]}
						/>
					</TableBoxLarge>
				</TablesWrapper>

				<TablesWrapper className="flexSpaceNull darkBg">
					<TableBoxLarge>
						<PricingTable
							title="Software Engineer"
							text="ANZ Bank | June 2023 - June 2025"
							offers={[
								{
									name: "Integrate software systems and cloud applications across domains.",
									checked: true,
								},
								{
									name: "Create templates, frameworks and documentaion for other development teams in Technology.",
									checked: true,
								},
								{
									name: "Build, maintain and deploy Node.js mediation services.",
									checked: true,
								},
								{
									name: "Utilise DataPower, Jenkins and Codefresh for efficient and reliable deployment processes.",
									checked: true,
								},
								{
									name: "Understand and comply with ANZ security and banking compliance standards.",
									checked: true,
								},
							]}
						/>
					</TableBoxLarge>
				</TablesWrapper>

				<TablesWrapper className="flexSpaceNull darkBg">
					<TableBoxLarge>
						<PricingTable
							title="Intern Full Stack Developer"
							text="Trade Me | Nov 2022 - Feb 2023"
							offers={[
								{
									name: "Demonstrated adaptability when working across the tech stack in Consumer Marketplace.",
									checked: true,
								},
								{
									name: "Quickly learned and utilized C# to create mock endpoints for Jobs and Motors listings, leading to increased efficiency in the Marketing API.",
									checked: true,
								},
								{
									name: "Configured and implemented a Time-To-Live (TTL) policy for expired documents in a Firestore database on GCP to ensure efficient data management.",
									checked: true,
								},
								{
									name: "Removed deprecated code and implemented modern CSS Grid solutions to enhance user experience and improve page layout, resulting in an optimised user interface.",
									checked: true,
								},
								{
									name: "Actively participated in team planning and agile ceremonies, demonstrating strong collaboration and communication skills.",
									checked: true,
								},
							]}
						/>
					</TableBoxLarge>
				</TablesWrapper>
				<TablesWrapper className="flexSpaceNull darkBg">
					<TableBoxLarge>
						<PricingTable
							title="Student Full Stack Developer"
							text="Dev Academy Aotearoa | Jan 2022 - May 2022"
							offers={[
								{
									name: "Learned and implemented new technologies daily in a distanced learning(remote) setting.",
									checked: true,
								},
								{
									name: "Participated in an in-depth human skills program with a focus on giving and receiving feedback, difficult conversations, bias mitigation, active listening, and effective communication in teams.",
									checked: true,
								},
								{
									name: "Pair programming and team projects, following agile methodologies.",
									checked: true,
								},
								{
									name: "Constant reflection on concepts to adapt and accelerate self-directed learning.",
									checked: true,
								},
								{
									name: "Javascript (ES6), React, Redux, Version Control(Git & GitHub), HTML5, CSS, Node.js, Express, APIs(REST), SQLite, SQL, Knex.js, Heroku deployment, Auth0, Stripe, TDD with Jest, Supertest and React Testing Library.",
									checked: true,
								},
							]}
						/>
					</TableBoxLarge>
				</TablesWrapper>

				<HeaderInfo>
					<h1 className="font40 bold">
						Volunteer
					</h1>
				</HeaderInfo>

				<TablesWrapper className="flexSpaceNull darkBg">
					<TableBoxLarge>
						<PricingTable
							title="Alumni Panel Member"
							text="Summer of Tech | April 2023 - Sept 2024"
							offers={[
								{
									name: "Participate in panel discussions aimed at sharing valuable insights and advice for students interested in the SoT program.",
									checked: true,
								},
							]}
						/>
					</TableBoxLarge>
				</TablesWrapper>
			</Wrapper>
		</div>
	);
}

const Wrapper = styled.section`
	width: 100%;
	padding: 10% 10%;
	min-height: 100vh;
`;
const HeaderInfo = styled.div`
	margin-top: 2rem;
`;
const TablesWrapper = styled.div`
	@media (max-width: 860px) {
		flex-direction: column;
	}
`;
const TableBoxLarge = styled.div`
	width: 100%;
	@media (max-width: 860px) {
		width: 100%;
		max-width: 370px;
		margin: 0 auto;
	}
`;
